import { Adapter as t } from "../../../adapter.js";
import { TicketItemModifierModel as o } from "./ticketItemModifier.model.js";
class m extends t {
  adapt(e) {
    return new o({
      skuCode: e.skuCode,
      name: e.name,
      quantity: e.quantity,
      subtotal: e.subtotal,
      taxes: e.taxes,
      total: e.total
    });
  }
  serialize(e) {
  }
}
export {
  m as TicketItemModifierAdapter
};
//# sourceMappingURL=ticketItemModifier.adapter.js.map
